import { FormattedMessage } from 'react-intl';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

const icons = {
	IconDashboard,
	IconDeviceAnalytics,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const CX = {
	id: 'CX',
	title: <FormattedMessage id="CX" />,
	icon: icons.IconDashboard,
	type: 'group',
	children: [
		{
			id: 'pricing-cx',
			title: <FormattedMessage id="CX" />,
			type: 'item',
			url: 'pricing-tool/CX',
			icon: CXIcon,
			breadcrumbs: false,
		},
	],
};

export default CX;

function CXIcon() {
	return (
		<svg
			width="24px"
			height="24px"
			viewBox="0 0 228 260"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M225.432,167.147L205.881,118v-15c-0.28-28.009-11.824-52.913-30.239-71.231c-17.543-17.451-41.408-28.661-67.809-29.684
			v70.333c18.505,7.174,31.667,25.155,31.667,46.163c0,24.915-18.507,45.581-42.494,48.995c4.996,14.542,18.801,25.026,35.017,25.026
			h21.82c2.023-5.351,7.179-9.163,13.238-9.163c7.822,0,14.163,6.341,14.163,14.163c0,7.822-6.341,14.163-14.163,14.163
			c-6.059,0-11.215-3.812-13.238-9.163h-21.82c-21.645,0-39.911-14.705-45.358-34.646C60.921,166.233,40.5,144.753,40.5,118.581
			c0-20.502,12.53-38.131,30.333-45.636V7.52C30.78,21.34,2,59.565,2,104.459c0,29.313,12.28,55.736,31.945,74.395L33.881,258h111.994
			v-20h20.006c22.082,0,40-17.83,40-40v-20h12C223.536,178,227.531,172.413,225.432,167.147z M177.83,128.996
			c-6.075,0-10.991-4.936-10.991-11.035s4.916-11.035,10.991-11.035s10.991,4.936,10.991,11.035
			C188.822,124.06,183.905,128.996,177.83,128.996z M65.5,118.581c0-13.509,10.991-24.5,24.5-24.5s24.5,10.991,24.5,24.5
			c0,13.51-10.991,24.5-24.5,24.5S65.5,132.091,65.5,118.581z"
				fill="currentColor"
			/>
		</svg>
	);
}
